import GLightbox from 'glightbox';
import Splide from '@splidejs/splide';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const galleries = [...document.querySelectorAll('.module-gal_imgs')];
const topSliders = [...document.querySelectorAll('.top-slider')];
// const roomSliders = [...document.querySelectorAll('.room-slider')];
const roomModules = [...document.querySelectorAll('.module-room')];
const gallerySliders = [...document.querySelectorAll('.gallery-slider')];
const blocEditos = [...document.querySelectorAll('.module-bloc_edito')];
const zenchef = [...document.querySelectorAll('.module-zenchef_module')];

// Header
const header = document.querySelector('header');

// Headers modules
const topImage = document.querySelector('.module-top_img');
const topSlider = document.querySelector('.module-top_slider');

/**
 * Initialize slider-fullscreen
 * @param { NodeList } slider
 * @param { Object } options
 */
function initSlider(slider, options) {
    const splide = new Splide(slider, options);
    splide.mount();
}

/**
 * Toggle Zenchef modal
 */
function toggleModalZenchef() {
    const zenchefModal = document.querySelector('.modal-zenchef_module');
    zenchefModal.classList.toggle('active');
}

// Slider Top
if (topSliders) {
    topSliders.forEach((slider) => {
        initSlider(slider, {
            autoplay: true,
            type: 'fade',
            height: '100vh',
            perPage: '1',
            pagination: false,
            arrows: false,
            cover: true,
            interval: 5000,
            rewind: true,
            dragMinThreshold: {
                mouse: 5,
                touch: 10
            }
        });
    });
}

// Galleries
if (galleries.length > 0) {
    // assign css class depending on nb of el
    galleries.forEach((gal) => {
        const nbCols = gal.children.length;
        if (nbCols === 2) gal.classList.add('col-2');
        if (nbCols === 4) gal.classList.add('col-4');
        if (nbCols === 6) gal.classList.add('col-6');
    });

    // eslint-disable-next-line no-unused-vars
    const lightbox = GLightbox({
        selector: '.glightbox',
        touchNavigation: true,
        loop: true
    });
}

// Slider Room
if (roomModules) {
    roomModules.forEach((roomModule) => {
        const slider = roomModule.querySelector('.room-slider');
        // todo: later put back slider : remove arrows/drag: false / restore drag options / autoplay : ??

        initSlider(slider, {
            autoplay: true,
            type: 'fade',
            height: '600px',
            perPage: '1',
            pagination: false,
            arrows: false,
            cover: true,
            interval: 5000,
            rewind: true,
            drag: false
            // dragMinThreshold: {
            //     mouse: 5,
            //     touch: 10
            // }
        });
    });

    // Check URL for fake anchors
    const queryString = window.location.search;
    const urlParams = new URLSearchParams(queryString);
    const roomId = urlParams.get('chambre');

    if (roomId) window.location.href = `#${roomId}`;
}

// Slider Gallery
if (gallerySliders) {
    gallerySliders.forEach((slider) => {
        initSlider(slider, {
            autoplay: true,
            type: 'loop',
            height: '400px',
            perPage: '1',
            pagination: false,
            cover: true,
            interval: 5000,
            rewind: true,
            dragMinThreshold: {
                mouse: 5,
                touch: 10
            }
        });
    });
}

// Header modules check
if (topImage || topSlider) {
    header.classList.add('absolute');
}

// Header modules check
if (blocEditos) {
    blocEditos.forEach((edito) => {
        const btnSeeMore = edito.querySelector('.see-more');
        const hiddenUl = edito.querySelector('.hidden-ul');
        const hiddenLis = [...edito.querySelectorAll('.hidden-li')];

        if (btnSeeMore) {
            btnSeeMore.addEventListener('click', () => {
                btnSeeMore.innerHTML = btnSeeMore.innerHTML === 'voir plus' ? 'voir moins' : 'voir plus';
                hiddenUl.classList.toggle('active');
                hiddenLis.forEach((li) => {
                    li.classList.toggle('active');
                });
            });
        }

        // Animation
        const el = edito.querySelector('.animated');
        const direction = edito.querySelector('.align').classList.contains('align-right') ? 'right' : 'left';

        if (direction === 'right') {
            gsap.from(el, {
                scrollTrigger: {
                    trigger: el,
                    toggleActions: 'restart complete none reset'
                },
                left: 600,
                duration: 1
            });
        }
        else {
            gsap.from(el, {
                scrollTrigger: {
                    trigger: el,
                    toggleActions: 'restart complete none reset'
                },
                right: 600,
                duration: 1
            });
        }
    });
}

// Zenchef
if (zenchef) {
    const zenchefLinks = [];
    const allLinks = [...document.querySelectorAll('a')];
    const closeModalBtn = document.querySelector('a.close-zendesk');

    allLinks.forEach((link) => {
        if (link.getAttribute('href') === '#book-restaurant') zenchefLinks.push(link);
    });

    zenchefLinks.forEach(link => link.addEventListener('click', () => toggleModalZenchef()));
    if (closeModalBtn) closeModalBtn.addEventListener('click', () => toggleModalZenchef());
}

// -------------------------------------------------------------------------------------------
// Responsive images in all modules ----------------------------------------------------------
const responsiveContents = [...document.querySelectorAll('.responsive_content')];

responsiveContents && responsiveContents.forEach(el => {
    const desktopContent = el.dataset.desktop
    const mobileContent = el.dataset.mobile

    if (mobileContent !== '') {
        handleResponsive(el, desktopContent, mobileContent)
        window.addEventListener("resize", () => handleResponsive(el, desktopContent, mobileContent))
    }
})

function handleResponsive(el, desktopContent, mobileContent) {
    if (el.dataset.type === 'bg') {
        if (window.innerWidth <= 768) {
            el.style.backgroundImage = `url('${mobileContent}')`
        }
        else {
            el.style.backgroundImage = `url('${desktopContent}')`
        }
    }

    if (el.dataset.type === 'img') {
        if (window.innerWidth <= 768) {
            el.src = mobileContent
        }
        else {
            el.src = desktopContent
        }
    }
}
// -------------------------------------------------------------------------------------------
